const onboardingRoutes = {
    onboardingFlow: {
        version_a: 'onboarding_flow_v1'
    }
}

export {
    onboardingRoutes
}